import type React from 'react'

import CompleteTheLook from '@frontend/features/products/complete-the-look/CompleteTheLook'
import ProductDetails from '@frontend/features/products/product-details/ProductDetails'
import ProductDetailsLoader from '@frontend/features/products/product-details/ProductDetailsLoader'
import RecentlyViewedProductSlider from '@frontend/features/products/recently-viewed-product-slider/RecentlyViewedProductSlider'
import RelatedProductSlider from '@frontend/features/products/related-product-slider/RelatedProductSlider'
import { ProductBreadcrumb } from '@scripts/frontend/features/products/components/ProductBreadcrumb'
import ErrorBoundary from '@shared/ErrorBoundary'
import NotFound from '@shared/screens/NotFound'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'

import useProduct from '../libs/hooks/useProduct'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { slug } = useParams<{ slug: string }>()
  const { data: product, error, isLoading } = useProduct().getBySlug(slug)

  if (isLoading) return <ProductDetailsLoader />

  if (error) {
    if ((error as { code?: string })?.code === 'not_found') {
      return <NotFound />
    }
    toast.error('Failed to fetch product')
    showBoundary(error)
  }

  if (!product) {
    showBoundary('No response data')
    return <></>
  }

  document.title = product.meta.title

  const completeTheLook = product?.completeTheLook
  const completeTheLookProducts = completeTheLook?.products || []
  const completeTheLookGallery = completeTheLook?.gallery || []

  return (
    <div className="my-12">
      <ProductBreadcrumb breadcrumbs={product.meta.breadcrumbs} />
      <ProductDetails product={product} />
      {completeTheLookProducts?.length > 0 &&
        completeTheLookGallery?.length > 0 && (
          <CompleteTheLook
            gallery={completeTheLookGallery}
            products={completeTheLookProducts}
          />
        )}
      <RelatedProductSlider products={product.upsellProducts} />
      <RecentlyViewedProductSlider />
    </div>
  )
}

function SingleProduct(): null | React.JSX.Element {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default SingleProduct
